<template>
  <div>
    <!-- 筛选 -->
    <el-form ref="Form" :inline="true" class="searchBoxLine my-search-line" :model="searchForm">
      <el-form-item label="申请单号：" prop="deliveryNum">
        <el-input v-model="searchForm.deliveryNum" placeholder="申请单号" maxlength="255" @input="e => searchForm.deliveryNum = handleInputRule (e)" />
      </el-form-item>
      <el-form-item label="合同编号：" prop="masterContractNum">
        <el-input v-model="searchForm.masterContractNum" placeholder="合同编号" maxlength="255" @input="e => searchForm.masterContractNum = handleInputRule (e)" @blur="searchForm.masterContractNum = (searchForm.masterContractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="项目名称：" prop="masterProjectName">
        <el-input v-model="searchForm.masterProjectName" placeholder="项目名称" maxlength="255" @input="e => searchForm.masterProjectName = handleInputRule (e)" />
      </el-form-item>
      <el-form-item label="状态：" prop="processState">
        <el-select v-model="searchForm.processState" placeholder="请选择状态">
          <el-option v-for="(item, index) in stateList" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间：" prop="startTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item" prop="endTime">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="是否需要唛头：" prop="markType">
        <el-select v-model="searchForm.markType" placeholder="请选择唛头">
          <el-option v-for="(item, index) in maiTitle" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button ref="searchBtn" type="primary" :loading="isLoading" @click="initData('search')">
          查询
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="isLoading" class="tableBody">
      <div class="operate-btn-wrap">
        <el-button type="primary" @click="exportInfo">
          导出分批发货申请单
        </el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="deliveryNum" label="申请单号" align="left" fixed="left" width="150">
          <template v-slot="{row}">
            <el-button type="text" @click="handleNum(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterContractNum" label="合同编号" align="left" fixed="left" width="150">
          <template v-slot="{row}">
            <el-button type="text" @click="handleContract(row)">
              {{ row.masterContractNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterProjectName" label="项目名称" align="left" width="200" />
        <el-table-column prop="receiptAddress" label="收货地址" align="left" width="200" />
        <el-table-column prop="partialInvoiceAmount" label="分批发货金额" align="right" header-align="left" width="100" />
        <el-table-column prop="createTime" label="申请日期" align="left" width="150" />
        <el-table-column prop="processStateStr" label="状态信息" align="left" />
        <el-table-column prop="markType" label="是否需要唛头" align="left" width="150" />
        <el-table-column prop="mark" label="唛头是否已制作" align="left" width="150">
          <template v-slot="{row}">
            <span v-if="row.mark === '否'">{{ row.mark }}</span>
            <el-button v-else type="text" @click="markSee(row)">
              {{ row.mark }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceNum" label="发货单号" align="left" width="150">
          <template v-slot="{row}">
            <el-button type="text" @click="handleGoods(row)">
              {{ row.invoiceNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="logisticsNum" label="物流单号" align="left" width="150">
          <template v-slot="{row}">
            <el-button type="text" @click="handleLogistics(row)">
              {{ row.logisticsNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="transferFromCode" label="操作" align="left" fixed="right" width="200">
          <template v-slot="{row}">
            <el-button v-if="row.processStateStr === '待付款'" type="text" @click="handleDistribute(row)">
              分配
            </el-button>
            <el-button v-if="row.processState === 1" type="text" @click="handleRecall(row)">
              召回
            </el-button>
            <!-- <el-button type="text" @click="handleMake(row)"> -->
            <el-button v-if="row.processState === 0 || row.processState === 3 || row.processState === 4" type="text" @click="handleEdit(row)">
              编辑
            </el-button>
            <el-button v-else-if="!row.printOrNot && row.processState !== 6" type="text" @click="handleMake(row)">
              制作唛头
            </el-button>
            <el-button v-if="row.processState === 3 || row.processState === 4" type="text" style="color: red" :loading="loadingBach" @click="handleReject(row)">
              废弃
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.pageIndex"
        :total="page.total"
        layout="total, prev, pager, next, jumper, sizes"
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>

    <!-- 申请单号 -->
    <requisitionedDetail
      ref="requisitionedDetailRef"
      title="查看发货单信息"
    />

    <!-- 大客户申请单号 -->
    <RequestMorePODetail ref="RequestMorePODetailRef" />
    <!--    商务编辑-->
    <DialogMoreAddress ref="DialogMoreAddressRef" @successSubmit="initData" />

    <!-- 发货产品清单  -->
    <goodsDetail ref="goodsDetail" />

    <!-- 快递单号 -->
    <logisticsProcess
      ref="logisticsProcessRef"
      :is-show="isLogisticsShow"
      @handle-cancel="isLogisticsShow = false"
    />

    <!-- 发货单编辑 -->
    <invoiceEdit
      ref="invoiceEdit"
      @init-data="initData"
    />

    <!-- 召回  -->
    <recallDialog ref="recallDialogRef" @set-data="initData" />

    <!-- 制作唛头 -->
    <makeList ref="makeListRef" @submit-make="submitMake" />

    <!-- 通用唛头模板制作唛头 -->
    <defaultTemp ref="defaultTempRef" @set-data="initData" />

    <!-- 个性唛头模板制作唛头 -->
    <personalityTemplate ref="personalityTemplate" @setData="initData" />

    <!-- 个性唛头模板电信 -->
    <telecomTemplate ref="telecomTemplateRef" @setData="initData" />

    <!-- 个性唛头模板制作唛头 -->
    <markSee ref="markSee" @open-edit="openEdit" />
    <!-- 查看通用唛头编辑 -->
    <defaultTempEdit ref="defaultTempEditRef" />
    <!-- 查看个性化唛头编辑 -->
    <personalityTempEdit ref="personalityTempEditRef" />
    <!-- 查看电信唛头 -->
    <dianxinPringDialog ref="dianxinPringDialogRef" @open-edit="openEdit" />
    <!-- 编辑电信唛头 -->
    <telecomTemplateEdit ref="telecomTemplateEditRef" @setData="initData" />
  </div>
</template>

<script>
import { handleInputRule } from '@/libs/util.js';
// 申请单号弹窗
import requisitionedDetail from './requisitionedDetail.vue';
// 发货产品清单
import goodsDetail from './goodsDetail.vue';
// 快递单号
import logisticsProcess from '@/components/logisticsProcess';
// 发货单编辑
import invoiceEdit from './invoiceEdit.vue';
// 召回原因
import recallDialog from './components/recallDialog.vue';
// 唛头列表
import makeList from './components/makeList.vue';
// 通用模版
import defaultTemp from './makeTemplate/defaultTemp.vue';
// 个性模板
import personalityTemplate from './makeTemplate/personalityTemplate.vue';
// 电信唛头
import telecomTemplate from './makeTemplate/telecomTemplate.vue';
// 查看唛头
import markSee from './components/markSee.vue';
// 查看通用唛头编辑
import defaultTempEdit from './components/defaultTempEdit.vue';
// 查看个性化唛头编辑
import personalityTempEdit from './components/personalityTempEdit.vue';
// 电信唛头
import dianxinPringDialog from './components/dianxinPringDialog.vue';
import telecomTemplateEdit from './components/telecomTemplateEdit.vue';
// 查看大客户订单详情
import RequestMorePODetail from './RequestMorePODetail.vue';
import {
  selectPartialInvoice,
  downloadPartialInvoice,
  partialInvoiceInvalid
} from '@/API';
import DialogMoreAddress from '@/views/Chief/contract/common/DialogMoreAddress.vue';
export default {
  components: {
    requisitionedDetail,
    goodsDetail,
    logisticsProcess,
    invoiceEdit,
    defaultTemp,
    personalityTemplate,
    makeList,
    recallDialog,
    markSee,
    defaultTempEdit,
    personalityTempEdit,
    telecomTemplate,
    dianxinPringDialog,
    telecomTemplateEdit,
    RequestMorePODetail,
    DialogMoreAddress
  },

  data () {
    return {
      isLogisticsShow: false, // 快递单号详情
      isLoading: false,
      searchForm: {},
      tableData: [],
      currentItem: {}, // Table操作某一项数据
      detailInfo: {},
      stateList: [
        { label: '全部', value: '' },
        { label: '订单员待审批', value: 1 },
        { label: '流程结束', value: 2 },
        { label: '已撤销', value: 3 },
        { label: '订单员已驳回', value: 4 }
      ],
      maiTitle: [
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ],
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      loadingBach: false
    };
  },

  created () {
    this.initData();
  },

  methods: {
    handleInputRule,
    initData (type) {
      this.isLoading = true;
      if (type === 'search') {
        this.page.pageIndex = 1;
      }
      const params = {
        ...this.searchForm,
        ...this.page,
        startTime: this.searchForm.startTime ? `${this.searchForm.startTime} 00:00:00` : '',
        endTime: this.searchForm.endTime ? `${this.searchForm.endTime} 23:59:59` : ''
      };
      delete params.total;
      selectPartialInvoice(params).then(res => {
        const { data } = res.data;
        this.page.total = data.total;
        this.tableData = data.list;
        this.isLoading = false;
      }).catch(e => {
        console.log(e);
        this.isLoading = false;
      });
    },

    // 申请单号
    handleNum (row) {
      if (!this.$store.getters.isAgent) {
        // 大客户查看详情
        this.$refs.RequestMorePODetailRef.openDialog(row);
        return;
      }
      this.$refs.requisitionedDetailRef.openDialog(row);
    },

    // 合同编号
    handleContract (row) {
      const routeUrl = this.$router.resolve({
        name: 'ContractInfo',
        params: { contractNum: row.masterContractNum },
        query: {
          id: row.masterContractId,
          masterProjectName: row.masterProjectName,
          distributeFlag: true
        }
      });
      window.open(routeUrl.href, '_blank');
    },

    // 唛头查看
    markSee (row) {
      this.currentItem = row;
      if (row.markTemplateId && row.markTemplateId === 34) {
        this.$refs.dianxinPringDialogRef.openDialog(row);
        return;
      }
      this.$refs.markSee.openDialog(row);
    },

    // 发货产品清单
    handleGoods (row) {
      this.$refs.goodsDetail.openDialog(row);
    },

    // 物流编号
    handleLogistics (row) {
      this.isLogisticsShow = true;
      this.$refs.logisticsProcessRef.initData(row.logisticsNum);
    },

    // 分配
    handleDistribute (row) {
      this.$router.push({ name: 'BatchBase',
        query: {
          ...row,
          contractNum: row.masterContractNum
        } });
    },

    // 召回
    handleRecall (row) {
      this.$refs.recallDialogRef.openDialog(row);
    },

    // 制作唛头
    handleMake (row) {
      this.currentItem = row;
      this.$refs.makeListRef.openDialog(row);
    },
    submitMake (val) {
      if (!val) return this.$message.error('请选择一项模版');
      switch (val) {
        case 12:
          this.$refs.defaultTempRef.openDialog({
            id: val,
            partialId: this.currentItem.id,
            markInfoId: this.currentItem.markId
          });
          break;
        case 34:
          this.$refs.telecomTemplateRef.openDialog({
            id: val,
            partialId: this.currentItem.id,
            markInfoId: this.currentItem.markId
          });
          break;
        default:
          this.$refs.personalityTemplate.openDialog({
            id: val,
            partialId: this.currentItem.id,
            markInfoId: this.currentItem.markId
          });
          break;
      }
      this.$refs.makeListRef.handleMakeClose();
      this.currentItem = {};
    },

    // 编辑
    handleEdit (row) {
      if (!this.$store.getters.isAgent) {
        this.$refs.DialogMoreAddressRef.openEditDialog(row);
        return;
      }
      this.$refs.invoiceEdit.openDialog(row);
    },

    // 查看唛头编辑
    openEdit (type) {
      if (type === 34) {
        this.$refs.telecomTemplateEditRef.openDialog({
          partialId: this.currentItem.id,
          markInfoId: this.currentItem.markId,
          id: type
        });
        return;
      }
      if (type === '个性模板') {
        this.$refs.personalityTempEditRef.openDialog({
          partialId: this.currentItem.id,
          markInfoId: this.currentItem.markId
        });
        return;
      }
      this.$refs.defaultTempEditRef.openDialog({
        partialId: this.currentItem.id,
        markInfoId: this.currentItem.markId
      });
    },

    exportInfo () {
      downloadPartialInvoice({
        ...this.searchForm
      }).then((res) => {
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = '分批发货申请单' + new Date().toLocaleString() + '.xlsx';
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement('a');
          link.download = fileName;
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    handerSizeChange () {
      this.page.pageIndex = 1;
      this.initData();
    },

    handerCurrentChange () {
      this.initData();
    },

    resetForm () {
      this.searchForm = {};
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.initData();
    },
    handleReject (row) {
      this.loadingBach = true;
      // 废弃接口
      this.$confirm('确定要废弃吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        partialInvoiceInvalid({ id: row.id }).then((res) => {
          let json = res.data;
          this.loadingBach = false;
          if (json.status === '200') {
            this.initData();
          } else {
            this.initData();
          }
        }).catch((res) => {
          console.log(res);
          this.loadingBach = false;
        });
      }).catch(() => {
        this.loadingBach = false;
      });
    }
  }
};
</script>

<style>
  .make-style .el-dialog__footer {
    padding-top: 0;
  }
  .make-style .el-row .el-col:nth-of-type(n + 3){
    margin-top: 12px;
  }
</style>

<style lang="scss" scoped>
.my-search-line {
  margin-bottom: 12px;
}
</style>
